/**
 * 描述：租户管理--基本信息设置
 * 日期：2017-10-13
 * 作者：liu_jinming
 */
'use strict';
angular.module('basicInfoSettingModule', [])
    .controller('basicInfoSettingCtrl', ['$scope', '$element', '$validation', '$rootScope', 'tManageMentService', 'modalDialog', 'trsHttpService', 'Upload', 'nameChange', function ($scope, $element, $validation, $rootScope, tManageMentService, modalDialog, trsHttpService, Upload, nameChange) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                globalName: nameChange.globalName,
                headPortrait: '',
                enterpriseName: '',
                enterpriseType: '',
                enterpriseCode: '',
                enterpriseAddress: '',
                expirationDate: '',
                enterpriseDesc: '',
                enterpriseIntr: '',
                enterpriseAreaCode: '',
                enterpriseNumber: '',
                status: '已停用',
                statusP: 0,
                LOGINFO: '',
                EMAIL: '',
                DOMAINADRESS: '',
                DOMAINADRESSPOSTFIX: '.com',
                SPEECHRATE: 264,
            };
            $scope.isShowImg = false;
            $scope.needSave = false;
            $scope.needSaveLeaderPic = false;
            $scope.needSaveLandPic = false;
        }

        /**
         * [initData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
            $scope.$on('$destroy', function () {
                requestData(true);
            });
        }

        /**
         * [getAttribute 获取属性中的语速]
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function getAttribute(data) {
            if (!!data.ATTRIBUTE) {
                var ATTRIBUTE = data.ATTRIBUTE.split('&');
                for (var i = 0; i < ATTRIBUTE.length; i++) {
                    if (ATTRIBUTE[i].indexOf('speechRate') > -1) {
                        $scope.status.SPEECHRATE = ATTRIBUTE[i].split('=')[1];
                    }
                }
            }
        }

        /**
         * [requestData description]
         * @return  {[type]}             [return description]
         */
        function requestData() {
            var params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'findTenantById'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.status.enterpriseType = data.TYPE;
                $scope.status.enterpriseName = data.TENANTNAME;
                $scope.status.enterpriseCode = data.ORGCODE;
                if (data.PROVINCE != data.CITY) {
                    $scope.status.enterpriseAddress = data.PROVINCE + data.CITY + data.COUNTY + data.ADDRESS;
                } else {
                    $scope.status.enterpriseAddress = data.CITY + data.COUNTY + data.ADDRESS;
                }
                getAttribute(data);
                var strT1 = data.STARTTIME.slice(0, 10);
                var strT2 = data.ENDTIME.slice(0, 10);
                $scope.status.expirationDate = strT1 + '  至  ' + strT2;
                $scope.status.enterpriseDesc = data.DESCRIPTION;
                $scope.status.enterpriseIntr = data.ABBREVIATION;
                var mobile = data.MOBILE.split('-');
                $scope.status.enterpriseAreaCode = mobile.length == 1 ? '' : mobile[0];
                $scope.status.enterpriseNumber = mobile.length == 1 ? mobile[0] : mobile[1];
                $scope.status.status = (data.STATUS === '1' ? '已停用' : '已启用');
                $scope.status.statusP = data.STATUS;
                $scope.status.LOGINFO = angular.isDefined(data.LOGINFO) ? data.LOGINFO : '';
                $scope.originalLogoName = angular.copy(data.LOGINFO);
                $scope.ObjectId = data.TENANTID;
                $scope.STARTTIME = data.STARTTIME;
                $scope.ENDTIME = data.ENDTIME;
                $scope.status.EMAIL = data.EMAIL;
                $scope.status.DOMAINADRESS = data.DOMAINADDRESS === 'i' ? '' : data.DOMAINADDRESS;
                $rootScope.$emit('updateTenantLogo', { url: $scope.status.leaderPic, name: $scope.status.LOGINFO });
                localStorage['updateTenantLogo'] = JSON.stringify({ url: $scope.status.leaderPic, name: $scope.status.LOGINFO, version: parseInt(Math.random() + 10000) }); // 跨窗口监控
            });
            var pretureParams = {
                'serviceid': 'mlf_tenant',
                'methodName': 'queryTenantLogos'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), pretureParams, 'post').then(function (data) {
                if (data.length == 2 || !data) { // 这其实是个空 无奈后端返回了"" 占了两个长度
                    $scope.status.leaderPic = './images/logo_1.png';
                } else {
                    $scope.status.leaderPic = data.replace(/\"/g, '');
                }
                $scope.isShowImg = true;
                $rootScope.$emit('updateTenantLogo', { url: $scope.status.leaderPic, name: $scope.status.LOGINFO });
                localStorage['updateTenantLogo'] = JSON.stringify({ url: $scope.status.leaderPic, name: $scope.status.LOGINFO, version: parseInt(Math.random() + 10000) }); // 跨窗口监控
            });
            var landParams = {
                'serviceid': 'mlf_tenant',
                'methodName': 'queryTenantLoginLogos',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), landParams, 'post').then(function (data) {
                if (data.length == 2 || !data) { // 这其实是个空 无奈后端返回了"" 占了两个长度
                    $scope.status.landPic = './images/logo_1.png';
                } else {
                    $scope.status.landPic = data.replace(/\"/g, '');
                }
                $scope.isShowImg = true;
            });
        }

        /**
         * [changeHeadPortrait description: 点击切换头像]
         * @param  {[type]} files    [description]文件类型
         * @param  {[type]} file     [description]文件名
         * @param  {[type]} newFiles [description]新建图片文件
         * @param  {[type]} fromType [description]上传的logo类型，是平台logo还是登录logo
         * @return {[type]}          [description]
         */
        $scope.changeHeadPortrait = function (files, file, newFiles, fromType) {
            Upload.upload({
                url: '/wcm/openapi/uploadImage',
                data: {
                    file: newFiles[0]
                },
            }).then(function (res) {
                res.tenantLogo = fromType;
                tManageMentService.uploadIsicon(res, fromType === '平台logo' ? undefined : (110 / 35)).then(function (data) {
                    if (fromType === '平台logo') {
                        $scope.status.leaderPic = data.imgSrc;
                        $scope.needSaveLeaderPic = true;
                        $scope.needSave = true;
                    } else {
                        $scope.status.landPic = data.imgSrc;
                        $scope.needSaveLandPic = true;
                    }
                });
            });
        };

        /**
         * [saveLandPic description] 保存登陆页LOGO
         *
         * @return  {[type]}  [return description]
         */
        function saveLandPic() {
            var params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'saveTenantLoginLogos',
                'logoinfo': $scope.status.landPic
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function () {
                requestData();
            });
        }

        /**
         * [saveLogo description] 保存企业LOGO
         *
         * @return  {[type]}  [return description]
         */
        function saveLogo() {
            $rootScope.$emit('updateTenantLogo', { url: $scope.status.leaderPic, name: $scope.status.LOGINFO });
            var params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'saveTenantLogos',
                'logoinfo': $scope.status.leaderPic
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function () {
                requestData();
            });
        }
        $scope.forbiddenBlank = function (event) {
            if (event.keyCode === 32) {
                event.target.value = event.target.value.trim();
            }
        };

        /**
         * [confirm description] 保存租户自己修改的内容
         *
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.confirm = function (type) {
            $validation.validate($scope.basicInfoSettingForm).success(function () {
                var params = {
                    'serviceid': 'mlf_tenant',
                    'methodName': 'updateTenantInfo',
                    'ObjectId': $scope.ObjectId,
                    'ABBREVIATION': $scope.status.enterpriseIntr,
                    'MOBILE': $scope.status.enterpriseAreaCode + '-' + $scope.status.enterpriseNumber,
                    'DESCRIPTION': $scope.status.enterpriseDesc,
                    'STARTTIME': $scope.STARTTIME,
                    'ENDTIME': $scope.ENDTIME,
                    'STATUS': $scope.status.statusP,
                    'LOGINFO': $scope.status.LOGINFO,
                    'DOMAINADDRESS': $scope.status.DOMAINADRESS === '' ? 'i' : $scope.status.DOMAINADRESS,
                    'SPEECHRATE': $scope.status.SPEECHRATE,
                    'bottomInfo': $scope.status.bottomInfo
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if ($scope.status.LOGINFO !== $scope.originalLogoName && !$scope.needSave) {
                        $rootScope.$emit('updateTenantLogo', { url: $scope.status.leaderPic, name: $scope.status.LOGINFO });
                        localStorage['updateTenantLogo'] = JSON.stringify({ url: $scope.status.leaderPic, name: $scope.status.LOGINFO, version: parseInt(Math.random() + 10000) }); // 跨窗口监控
                        requestData();
                    }
                    if ($scope.needSaveLeaderPic) {
                        saveLogo();
                        $scope.needSaveLeaderPic = false;
                        $scope.needSave = false;
                    }
                    if ($scope.needSaveLandPic) {
                        saveLandPic();
                        $scope.needSaveLandPic = false;
                    }
                    modalDialog.alertType('', '修改成功', 'success', false);
                });
            }).error(function () {
                angular.invalidPosition($scope.basicInfoSettingForm, $element);
            });
        };

        /**
         * [preview description: 预览]
         * @return {[type]}          [description]
         */
        $scope.preview = function () {
            if ($scope.basicInfoSettingForm.logoinfo.$invalid) {return;}
            tManageMentService.previewLogo({ url: $scope.status.leaderPic, name: $scope.status.LOGINFO });
        };
    }]).config(['$validationProvider', function ($validationProvider) {
        var expression = {
            domainnameprefix: function (value) {
                if (value.toLowerCase() === 'i') {return false;} else {return true;}
            }
        };
        var validMsg = {
            domainnameprefix: {
                error: 'i.tmuyun.com为系统保留域名，请输入其他域名',
                success: ''
            }
        };
        $validationProvider.setExpression(expression) // set expression
            .setDefaultMsg(validMsg); // set valid message
    }
    ]);
